import {
  Amwins_Portal_Api_Services_LockService_UserLock,
  Amwins_Portal_Api_Services_LockService_Domain,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class LockService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static get(
    params: {
      /**  */
      domain: any | null;
      /**  */
      key: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Amwins_Portal_Api_Services_LockService_UserLock> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Lock/{domain}/{key}';
      url = url.replace('{domain}', params['domain'] + '');
      url = url.replace('{key}', params['key'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static put(
    params: {
      /**  */
      domain: any | null;
      /**  */
      key: string;
      /**  */
      duration?: number;
      /**  */
      contest?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Amwins_Portal_Api_Services_LockService_UserLock> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Lock/{domain}/{key}';
      url = url.replace('{domain}', params['domain'] + '');
      url = url.replace('{key}', params['key'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { duration: params['duration'], contest: params['contest'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      domain: any | null;
      /**  */
      key: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/Lock/{domain}/{key}';
      url = url.replace('{domain}', params['domain'] + '');
      url = url.replace('{key}', params['key'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
